import { toast } from 'sonner';

import { Button } from '../../../components/Button';
import { statusToastMessage, ticketErrorRO } from '../ticketCopy';
import { useSetTicketStatusMutation } from '../tickets.api';
import { TICKET_STATUSES, TICKET_STATUS_LABELS, type TicketStatus } from '../tickets.schema';

export function TicketStatusChanger({ id, status }: { id: number; status: TicketStatus }) {
    const [setStatus, { isLoading }] = useSetTicketStatusMutation();

    const change = async (next: TicketStatus) => {
        if (next === status) return;
        try {
            await setStatus({ id, status: next }).unwrap();
            toast.success(statusToastMessage(next));
        } catch (e) {
            toast.error(ticketErrorRO(e, 'Eroare la actualizarea statusului.'));
        }
    };

    return (
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
            {TICKET_STATUSES.map((s) => (
                <Button
                    key={s}
                    size="lg"
                    variant={s === status ? 'primary' : 'secondary'}
                    disabled={isLoading || s === status}
                    onClick={() => change(s)}
                >
                    {TICKET_STATUS_LABELS[s]}
                </Button>
            ))}
        </div>
    );
}
